import { gql } from "apollo-boost"

export const getCommentsInvoiceMonth = gql`
  query FinancialMonitoringInvoiceMonthComments($monitoringFinancialInvoiceMonth: ID!) {
    FinancialMonitoringInvoiceMonthComments(monitoringFinancialInvoiceMonth: $monitoringFinancialInvoiceMonth) {
      id
      createdAt
      userType
      comment
      parentCommentId 
    }
  }
`
